import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DatabaseService } from 'src/app/shared/services/database.service';
import { CommunityTenancyData } from 'src/lib/fliko/models/agreements/communityTenancy.data';
import { TenancyAgreementData } from 'src/lib/fliko/models/agreements/tenancyAgr.data';
import { Nullish } from 'src/lib/fliko/types/typeish.type';
import { UpdateIdOnly } from 'src/lib/fliko/types/update.type';

@Injectable({ providedIn: 'root' })
export class AgreementService {
  constructor(private dbSrv: DatabaseService) {}

  // #region PRS Agreement
  /**
   * @path /tenancyAgreement/$estateId/
   * @key id
   */
  private get tenancyAgreement() {
    return this.dbSrv.estateFactory.getCollection<TenancyAgreementData>('tenancyAgreement/$eId');
  }

  public getPrsAgreements$(): Observable<TenancyAgreementData[]> {
    return this.tenancyAgreement.getList();
  }

  public getPrsAgreementsOnce(): Promise<TenancyAgreementData[]> {
    return this.tenancyAgreement.onceList();
  }

  public getPrsAgreement$(id: string): Observable<TenancyAgreementData | Nullish> {
    return this.tenancyAgreement.getElement(id);
  }

  public setPrsAgreement(agreement: TenancyAgreementData): Promise<void> {
    return this.tenancyAgreement.setElement(agreement.id, agreement);
  }

  public updatePrsAgreement(agreement: UpdateIdOnly<TenancyAgreementData>): Promise<void> {
    return this.tenancyAgreement.updateElement(agreement.id, agreement);
  }
  // #endregion PRS Agreement

  // #region Community Agreement
  /**
   * @path /tenancyInCommunity/$estateId/
   * @key id
   */
  private get tenancyInCommunity() {
    return this.dbSrv.estateFactory.getCollection<CommunityTenancyData>('tenancyInCommunity/$eId');
  }

  /**
   * @param {string} tenantId
   * @path /tenancyInCommunity/$estateId/
   * @key id
   */
  private tenancyInCommunityByTenant = (tenantId: string) =>
    this.dbSrv.estateFactory.getCollectionReadOnly<CommunityTenancyData>('tenancyInCommunity/$eId', {
      by: { child: 'tenantId' },
      equalTo: tenantId
    });

  public getCommAgreement$(): Observable<CommunityTenancyData[]> {
    return this.tenancyInCommunity.getList();
  }

  public getCommAgreementByTenant$(id: string): Observable<CommunityTenancyData[]> {
    return this.tenancyInCommunityByTenant(id).getList();
  }

  public setCommAgreement(tenancy: CommunityTenancyData): Promise<void> {
    return this.tenancyInCommunity.setElement(tenancy.id, tenancy);
  }

  public cancelCommAgreement(tenancy: CommunityTenancyData): Promise<void> {
    return this.tenancyInCommunity.setElementChild(tenancy.id, 'cancelDate', Date.now());
  }

  // #endregion Community Agreement
}
